import React, {useRef, useEffect, useState, useLayoutEffect} from 'react'
import {Html} from '@react-three/drei'
import useInputStore from '../store/inputStore'
import useProfileStore from '../store/profileStore'
import * as THREE from 'three'
  
const EditBox = () => {
  const position = useInputStore(state => state.position)
  const text = useInputStore(state => state.text)
  const index = useInputStore(state => state.index)
  const type = useInputStore(state => state.type)
  const data = useInputStore(state => state.data)

  // const attributes = useInputStore(state => state.attributes)
  const setEditMode = useInputStore(state => state.setEditMode)
  const editMode = useInputStore(state => state.editMode)

  const selectedPts = useProfileStore(state => state.selectedPts)
  const replaceSelectedPts = useProfileStore(state => state.replaceSelectedPts)
  const inputRef = useRef()

  const [inputText, setInputText] = useState(text)

  const updateSelectedPts = (updatedValue, index) => {
    if (type === 'length'){
      const vec1 = new THREE.Vector3(
        selectedPts[index][0] - selectedPts[index - 1][0],
        selectedPts[index][1] - selectedPts[index - 1][1],
        0
        )
      const vec2 = vec1.clone();
      const valueUpdated = parseFloat(updatedValue) //need to check that vetted data is entered
      // console.log('valueUpdated', valueUpdated)
      if (valueUpdated > 0){
          vec1.setLength(valueUpdated)
          vec1.sub(vec2);
          let tmpArray = [];
          for (let i = 0; i < index; i++){
            tmpArray.push(selectedPts[i])
          }
          for (let i = index; i < selectedPts.length; i++){
            const newPt = [selectedPts[i][0] + vec1.x, selectedPts[i][1] + vec1.y, 0];
            tmpArray.push(newPt)
          }
          replaceSelectedPts(tmpArray)
        }
    } else if (type === 'angle'){


      const refAngle =  new THREE.Vector3(1,0,0);
      const vec1 = new THREE.Vector3(
        selectedPts[index][0] - selectedPts[index - 1][0],
        selectedPts[index][1] - selectedPts[index - 1][1],
        0
        ) //Vector of first segment forming given angle
      const vec2 = new THREE.Vector3(
          selectedPts[index + 1][0] - selectedPts[index][0],
          selectedPts[index + 1][1] - selectedPts[index][1],
          0
          ) //Vector of first segment forming given angle 
      const ang1 = vec1.y < 0 ? 2 * Math.PI - vec1.angleTo(refAngle) : vec1.angleTo(refAngle)
      const ang2 = vec2.y < 0 ? 2 * Math.PI - vec2.angleTo(refAngle) : vec2.angleTo(refAngle)
      const angleStart = Math.abs(ang1 - ang2) > Math.PI ? Math.max(ang1, ang2) : Math.min(ang1, ang2);

      const angleOld = parseFloat(data) * 180 / Math.PI;
      const angleNew = parseFloat(inputText);


      const angleDiffDeg = Math.abs(angleStart - ang2) < 0.001 ?  angleNew - angleOld : angleOld - angleNew;
      const angleDiffRad = angleDiffDeg * Math.PI / 180;

      // console.log('angle Old', angleOld)
      // console.log('angle New', angleNew)
      // console.log('angle Diff Deg', angleDiffDeg)
      // console.log('angle Diff Rad', angleDiffRad)
      if (Math.round(Math.abs(angleDiffDeg)) > 0){

        const origin = new THREE.Vector3(selectedPts[index][0],selectedPts[index][1], 0);
        const rotationMatrix = new THREE.Matrix3();
        rotationMatrix.set(Math.cos(angleDiffRad), -1*Math.sin(angleDiffRad), 0,
        Math.sin(angleDiffRad), Math.cos(angleDiffRad), 0,
        0,0,0)
      

        let tmpArray = [];
        for (let i = 0; i < index + 1; i++){
          tmpArray.push(selectedPts[i])
        }
        for (let i = index + 1; i < selectedPts.length; i++){
          const pt = new THREE.Vector3(selectedPts[i][0],selectedPts[i][1],0);
          pt.sub(origin);
          pt.applyMatrix3(rotationMatrix);
          pt.add(origin);

          tmpArray.push(pt.toArray())
        }
        replaceSelectedPts(tmpArray)

      }
    }

  }

  const handleChange = (e) => {
    e.stopPropagation()
    setInputText(e.target.value)
  }


  useEffect(() => {
    if(editMode){
      inputRef.current.focus();
      console.log('index', index)
    }
  }, [editMode])

  useLayoutEffect(() => {
    setInputText(text)
    console.log('text',text)
  },[text])


  const handleBlur = (e) => {
    e.stopPropagation()
    if(editMode){
      updateSelectedPts(inputRef.current.value, index)
      setEditMode(false)
      console.log('blur')
    }
  }

  const handlePointerUp = (e) => {

    if(e.key === 'Enter' || e.keyCode === 13){
      handleBlur(e)
    }
  }
  return (
    <>
      <Html center position={position}>
        {<input 
          ref={inputRef} 
          value={inputText} 
          onChange={handleChange}
          onKeyUp={handlePointerUp}
          style={{height: editMode? '2em' : '0',
                 width: editMode? '5em' : '0', 
                 padding: editMode? '2px' : '0',
                 border: editMode? '2px' : '0'}}
          onBlur={handleBlur}
          />}
      </Html>
    </>
  )
}

export default EditBox
